function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDensityComfortablei = function SvgDensityComfortablei(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M19.801 20.112c0 .384.25.705.7.705.34 0 .71-.138.7-.705v-.229a1.7 1.7 0 0 0-1.7-1.7h-15a1.7 1.7 0 0 0-1.7 1.7c0 .836.43.942.7.934.27 0 .7-.085.7-.934 0-.166.13-.3.3-.3h15c.17 0 .3.134.3.3zm2.4-11.633a1.7 1.7 0 0 0-1.7-1.7h-17a1.7 1.7 0 0 0-1.7 1.7v7.042a1.7 1.7 0 0 0 1.7 1.7h17a1.7 1.7 0 0 0 1.7-1.7zm-1.4 0v7.042c0 .166-.13.3-.3.3h-17c-.17 0-.3-.134-.3-.3V8.479c0-.166.13-.3.3-.3h17c.17 0 .3.134.3.3M9.701 12c0-1.214-.99-2.2-2.2-2.2s-2.2.986-2.2 2.2.99 2.2 2.2 2.2 2.2-.986 2.2-2.2m-1.4 0a.8.8 0 1 1-1.6 0 .8.8 0 1 1 1.6 0m3.73.7h5.79c.38 0 .7-.314.7-.7s-.32-.7-.7-.7h-5.79a.7.7 0 1 0 0 1.4m7.77-8.803c0-.384.25-.706.7-.706.34 0 .71.138.7.706v.229a1.7 1.7 0 0 1-1.7 1.7h-15a1.7 1.7 0 0 1-1.7-1.7c0-.837.43-.942.7-.935.27 0 .7.085.7.935 0 .166.13.3.3.3h15c.17 0 .3-.134.3-.3z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDensityComfortablei);
export default ForwardRef;